import React, { useEffect, useMemo, useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNACard, DNAIcon, DNAText, Iffy, Popover, } from "../../../index";
import Collapsible from "../../util/Collapsible/Collapsible";
import colors from "../../../theming/themes/alucio/colors";
const styles = StyleSheet.create({
    wrapper: {
        paddingHorizontal: 18,
        paddingVertical: 16,
    },
    content: {
        borderTopColor: colors['color-gray-80'],
        borderTopWidth: 1,
    },
    DNACard: {
        minHeight: 'fit-content',
        borderRadius: 4,
    },
    selected: {
        minHeight: 'fit-content',
        borderRadius: 4,
        borderWidth: 2,
        borderColor: colors['color-primary-500'],
    },
});
var VariantOptions;
(function (VariantOptions) {
    VariantOptions["default"] = "default";
    VariantOptions["publisherReadonly"] = "publisherReadonly";
    VariantOptions["darkMode"] = "darkMode";
})(VariantOptions || (VariantOptions = {}));
const variantHeaderStyle = {
    default: styles.wrapper,
    publisherReadonly: { ...styles.wrapper, paddingVertical: 5, paddingHorizontal: 8 },
    darkMode: {
        ...styles.wrapper,
        backgroundColor: colors['color-gray-800'],
        borderWidth: 0,
        borderColor: colors['color-gray-600'],
        paddingHorizontal: 10,
        paddingVertical: 9,
    },
};
const variantCardStyle = {
    default: styles.DNACard,
    publisherReadonly: styles.DNACard,
    darkMode: { ...styles.DNACard, borderColor: colors['color-gray-600'], borderWidth: 1, borderRadius: 4 },
};
const variantCardSelectedStyle = {
    default: styles.selected,
    publisherReadonly: styles.selected,
    darkMode: { ...styles.selected, borderWidth: 1, borderColor: colors['color-gray-600'] },
};
const DNACollapsibleCard = ((props) => {
    const { collapsedDefault, headerTitle, popoverInfoText, children, customWrapperStyle, numberOfTitleLines, selected, collapseOverride, collapseButtonSize, variant = VariantOptions.default, } = props;
    const [isCollapsed, setIsCollapsed] = useState(!!collapsedDefault);
    const headerStyle = variantHeaderStyle[variant];
    function toggleCollapse() {
        setIsCollapsed(open => !open);
        props.onToggleChanged?.(!isCollapsed);
    }
    useEffect(() => {
        if (props.isCollapsed !== undefined) {
            setIsCollapsed(props.isCollapsed);
        }
    }, [props.isCollapsed]);
    const { actionContainer, childrenContent } = useMemo(() => {
        return React.Children
            .toArray(children)
            .reduce((acc, child) => {
            if (React.isValidElement(child)) {
                // @ts-expect-error
                const displayName = child.type?.displayName;
                if (displayName === DNACollapsibleActionMenu.displayName) {
                    acc.actionContainer = child;
                    return acc;
                }
            }
            acc.childrenContent.push(child);
            return acc;
        }, {
            actionContainer: null,
            childrenContent: [],
        });
    }, [children]);
    return (<DNABox appearance="col" spacing="md">
      <DNACard testID="collapsed-header-container" style={selected ? variantCardSelectedStyle[variant] : variantCardStyle[variant]} appearance="outline">
        {/* HEADER */}
        <Pressable onPress={toggleCollapse}>
          <DNABox style={headerStyle} spacing="between" alignY="center" 
    // we need to fill the available space in order to be able to truncate the titles
    childStyle={actionContainer ? [0, { flex: 1 }] : undefined}>
            <DNABox spacing="sm" alignY="center" 
    // we need to fill the available space in order to be able to truncate the titles
    childStyle={actionContainer ? [1, { flex: 1 }] : undefined}>
              <DNAButton appearance="ghost" status={variant === VariantOptions.darkMode ? 'subtle' : 'tertiary'} colorMode={variant === VariantOptions.darkMode ? 'dark' : undefined} rounded iconLeft={!isCollapsed ? 'caret-down' : 'caret-right'} onPress={toggleCollapse} size={collapseButtonSize}/>
              {typeof headerTitle === 'string' ? <DNAText b1 bold numberOfLines={numberOfTitleLines ?? undefined} status={variant === VariantOptions.darkMode ? 'subtle' : undefined}>
                {headerTitle}
              </DNAText> : <DNABox>{headerTitle}</DNABox>}
            </DNABox>
            {/* TODO: find another way to add the actionComponent */}
            <Iffy is={popoverInfoText}>
              <Popover>
                <Popover.Anchor>
                  <DNAIcon.Styled status="subtle" name="question"/>
                </Popover.Anchor>
                <Popover.Content>
                  <DNAText colorMode='dark'>{popoverInfoText}</DNAText>
                </Popover.Content>
              </Popover>
            </Iffy>
            {actionContainer}
          </DNABox>
        </Pressable>
        <Collapsible collapsed={collapseOverride ?? isCollapsed} style={variant === VariantOptions.darkMode
            ? { backgroundColor: colors['color-gray-500'] } : {}}>
          {/* CONTENT */}
          <DNABox appearance="col" spacing={isCollapsed ? undefined : 'md'} style={[styles.wrapper, styles.content, customWrapperStyle]}>
            {childrenContent}
          </DNABox>
        </Collapsible>
      </DNACard>
    </DNABox>);
});
export const DNACollapsibleActionMenu = (props) => props.children;
DNACollapsibleActionMenu.displayName = 'DNACollapsibleActionMenu';
export default DNACollapsibleCard;
//# sourceMappingURL=DNACollapsibleCard.js.map